import { CustomerType, ProductSearchRequestModel } from 'app/shared/models/productSearchRequestModel';

import { AddressDetailModel } from 'app/shared/models/address/address.model';
import { CurrentSearchRequestModel } from 'app/shared/models/current-search-request.model';
import { LocationWrapper } from 'app/shared/utilities/location-wrapper';
import { ProductCategory } from 'app/shared/models/product-category.model';
import { QueryStringParamName } from 'app/shared/models/common.enums';
import { SearchRequestType } from 'app/shared/models/energy/energy.enums';
import { StoreKeys } from 'app/shared/constants/store-keys.enum';
import { addressService } from 'app/shared/services/address/address.service';
import { store } from 'app/shared/store/store';

class EnergyRequestMapper {
  public mapProductSearchRequestModel(
    address: AddressDetailModel,
    customerType: CustomerType,
    productCategories: ProductCategory[],
    locationWrapper: LocationWrapper = new LocationWrapper()
  ): ProductSearchRequestModel {
    const productSearchRequestModel = new ProductSearchRequestModel();
    if (address) {
      productSearchRequestModel.floorNumber = address.floor ? address.floor : null;
      productSearchRequestModel.unitNumber = address.unitNumber ? address.unitNumber : null;
      productSearchRequestModel.streetNumber = address.streetNumber ? address.streetNumber : null;
      productSearchRequestModel.streetName = address.streetName ? address.streetName : null;
      productSearchRequestModel.streetType = address.streetType ? address.streetType : null;
      productSearchRequestModel.streetTypeSuffix = address.streetTypeSuffix ? address.streetTypeSuffix : null;
      productSearchRequestModel.suburb = address.suburb ? address.suburb : null;
      productSearchRequestModel.state = address.state;
      productSearchRequestModel.postcode = address.postcode;
      productSearchRequestModel.customerType = customerType;
      productSearchRequestModel.latitude = address.latitude;
      productSearchRequestModel.longitude = address.longitude;
      productSearchRequestModel.deliveryPointId = address.deliveryPointIdentifier;
      productSearchRequestModel.webCampaignId = store.get(StoreKeys.isCampaignPage)
        ? null
        : locationWrapper.getParamValue(QueryStringParamName.WebId);
      productSearchRequestModel.productCategoriesToSearch = productCategories;
    }
    return productSearchRequestModel;
  }

  public mapToCurrentSearchRequestModel(
    address: AddressDetailModel,
    customerType: CustomerType = CustomerType.residential,
    productCategories: ProductCategory[] = null,
    searchRequestType: SearchRequestType = SearchRequestType.address
  ): CurrentSearchRequestModel {
    const productSearchRequestModel = this.mapProductSearchRequestModel(address, customerType, productCategories);

    const addressString = address ? addressService.convertAddressToString(address) : null;

    const currentSearchRequestModel = new CurrentSearchRequestModel(
      searchRequestType,
      productSearchRequestModel,
      addressString,
      address?.addressId
    );

    return currentSearchRequestModel;
  }
}

export const energyRequestMapper = new EnergyRequestMapper();
